<template>
    <SignInForm />
</template>

<script lang="ts">
    import { defineComponent } from "vue";
    import SignInForm from "@views/public/sign-in/sign-in-form.vue";

    export default defineComponent({
        components: {
            SignInForm,
        },
    })
</script>
